import { Alert, Box, Container, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

type Props = {
  title: string;
  /** API の失敗（入力欄ではなくフォーム上部に出す） */
  error?: string;
  /** 案内（確認コードを送った等） */
  info?: string;
  children: ReactNode;
};

/**
 * 自前ログイン画面の共通枠。ヘッダー・サイドメニュー・フッターは出さず、
 * ロゴ → 太字タイトル → Alert → フォームの順（SignUpConfirmation と同じ Container xs）。
 */
export default function AuthFrame({ title, error, info, children }: Props) {
  return (
    <Container maxWidth="xs" sx={{ py: [6, 10] }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
        <img src="/logo.png" alt="競書才幹" height={40} />
      </Box>
      <Typography variant="h5" component="h1" textAlign="center" sx={{ fontWeight: 'bold', mb: 4 }}>
        {title}
      </Typography>
      {info ? (
        <Alert severity="info" sx={{ mb: 3 }}>
          {info}
        </Alert>
      ) : null}
      {error ? (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      ) : null}
      {children}
    </Container>
  );
}
